var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{class:_vm.whiteC ? 'whiteC' : '',attrs:{"separator":"/"}},_vm._l((_vm.$store.state.breadList),function(item){return _c('el-breadcrumb-item',{key:item.url,staticStyle:{"color":"#FFFFFF"},attrs:{"to":{ path: item.url,query:item.query,params:item.params }}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }